export type Transaction = {
  id: string;
  userId: string;
  storeItemId: string;
  pricePaid: number;
};
